import store from "@/state/store";

export function hasPermission(requiredPermissions) {
    const userPermissions = store.state.authApi.permissions;

    // Check if user permissions are available
    if (!Array.isArray(userPermissions) || userPermissions.length === 0) {
        console.warn("No permissions available.");
        return false; // No permissions means no access
    }

    // Check if any of the required permissions are included in the user's permissions
    return requiredPermissions.some(permission => userPermissions.includes(permission));
}

export function nextAllowPage() {
    const userPermissions = store.state.authApi.permissions;

    // List of allowed pages and their required permissions
    const allowPages = [
        { permission: 'expenses-view', page: 'expenses' },
        { permission: 'bills-view', page: 'bills' },
        { permission: 'transfers-view', page: 'transfers' },
        { permission: 'payments-view', page: 'payments' },
    ];

    // Check if user permissions are available
    if (!Array.isArray(userPermissions) || userPermissions.length === 0) {
        console.warn("No permissions available.");
        return false; // No permissions mean no access
    }

    // Find and return the page name for the first matching permission
    const allowedPage = allowPages.find(item => userPermissions.includes(item.permission));

    if (allowedPage) {
        console.log(`Permission found for page: ${allowedPage.page}`);
        return allowedPage.page; // Return the page name
    } else {
        console.warn("No matching permissions found.");
        return false; // No matching permissions
    }
}
